<template>
    <div class="flex flex-col content-center justify-center max-w-sm mx-auto mt-12 lg:w-full lg:max-w-md">
        <div class="flex justify-center text-4xl font-semibold text-gray-900">
            Email verified!
        </div>
        <div class="p-2 mt-12 text-gray-800">Awesome! You should be redirected in {{ time }} seconds!</div>
        <div class="p-2 text-gray-500">
            If it doesn't,
            <router-link tag="a" :to="{ name: 'signin', params: { message: `Awesome! You're signup and ready to go!` } }" class="font-semibold text-blue-500"
                >click here</router-link
            >
        </div>
    </div>
</template>
<script>
import api from '@/client';

export default {
    name: 'signup-email-confirm',
    data() {
        return {
            time: 10,
            isRunning: false,
            interval: 1000,
            verified: 'loading',
        };
    },
    created() {
        api('confirm', { params: { key: this.$route.query.key } }).then(response => {
            if (response.status === 200 || response === 201) {
                this.verified = 'success';
                this.$store.dispatch('users/signout');
            } else {
                this.verified = 'error';
            }
        });
    },
    mounted() {
        setTimeout(() => {
            this.$router.push({
                name: 'signin',
                params: { message: `Awesome! You're signed up and ready to go!` },
            });
        }, this.time * 1000);
        this.toggleTimer();
    },
    methods: {
        toggleTimer() {
            if (this.isRunning) {
                clearInterval(this.interval);
            } else {
                this.interval = setInterval(this.incrementTime, this.interval);
            }
            this.isRunning = !this.isRunning; // better to read
        },
        incrementTime() {
            this.time = --this.time;
        },
    },
};
</script>
